<template>
  <DropdownTarget v-slot="{ show, visible }">
    <BasicButton @click="show" title="Скачать отклик" appearance="icon-only">
      <SvgIcon icon="download" size="24" :source="$options.icons" />
    </BasicButton>
    <BasicDropdown v-if="visible" placement="top" class="template-modal--width">
      <div>
        <BasicButton
          :href="`/vacancies/${vacancyId}/responses/${responseId}/print`"
          appearance="dropdown-list-item"
          target="_blank"
        >
          Печатная версия
        </BasicButton>
      </div>
      <div>
        <BasicButton
          :href="`/vacancies/${vacancyId}/responses/${responseId}/print.pdf`"
          appearance="dropdown-list-item"
          target="_blank"
        >
          PDF
        </BasicButton>
      </div>
      <div>
        <BasicButton
          :href="`/vacancies/${vacancyId}/responses/${responseId}/print.docx`"
          appearance="dropdown-list-item"
          target="_blank"
        >
          DOC
        </BasicButton>
      </div>
    </BasicDropdown>
  </DropdownTarget>
</template>

<script>
import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'ResponseDownloadButton',

  components: {
    BasicButton,
    BasicDropdown,
    DropdownTarget,
    SvgIcon,
  },

  icons: '/images/responses-v3.svg',

  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    responseId: {
      type: Number,
      required: true,
    },
  },
};
</script>
